import React from 'react';

interface RequireWorkflowPlannerProps {
  children: React.ReactElement;
}

/**
 * Soft gate: operations mapping is optional (Advanced) for MSMEs.
 * Linear path is Bills → Footprint → Report — never hard-redirect to /operations.
 */
const RequireWorkflowPlanner: React.FC<RequireWorkflowPlannerProps> = ({ children }) => children;

export default RequireWorkflowPlanner;
